import type { StateTree } from '@makemydeal/dr-dash-types';
import type { AcceleronTaxItems, paymentServicesTypes, TaxName } from '@makemydeal/dr-platform-types';
import { TaxNames } from '@makemydeal/dr-platform-types';
import {
    capitalizeTaxItems,
    getAdvanceSalesTax,
    getCapCostReductionTax,
    getCapReductionTaxCapitalizedIndicator,
    getTaxItemsWithOverridesWithoutFlat,
    isTaxCapped
} from '../selectors/offerRedux';
import type { TaxCategoryTypes, TaxDisplayCategories } from '../types/types';
import { TaxCategory } from '../types/types';

type CappedFlags = { isTaxCapped?: boolean; isCrtCapped?: boolean };

export const setManualTaxes = (state: StateTree, isCapped?: boolean): AcceleronTaxItems => {
    const taxItems = getTaxItemsWithOverridesWithoutFlat(state);

    if (isCapped == null) {
        return taxItems;
    }

    const { upfrontTaxes, capitalizedTaxes } = categorizeTaxes(taxItems, { isTaxCapped: isCapped, isCrtCapped: isCapped });

    return capitalizeTaxItems([...upfrontTaxes, ...capitalizedTaxes], isCapped);
};

export const getTaxCategory = (isCapped: boolean = false): TaxCategoryTypes => {
    return isCapped ? TaxCategory.CAPITALIZED : TaxCategory.UPFRONT;
};

export const isTermAllTaxCapitalized = (state: StateTree): boolean => {
    const advanceSalesTax = getAdvanceSalesTax(state);
    const capCostReductionTax = getCapCostReductionTax(state);

    const flags = [];

    if (advanceSalesTax > 0) flags.push(isTaxCapped(state));
    if (capCostReductionTax > 0) flags.push(getCapReductionTaxCapitalizedIndicator(state));

    return flags.length > 0 && !flags.includes(false);
};

export const categorizeTaxes = (taxItems: paymentServicesTypes.TaxItems, cappedFlags: CappedFlags = {}): TaxDisplayCategories => {
    const categorizedTaxes: TaxDisplayCategories = {
        [TaxCategory.UPFRONT]: [],
        [TaxCategory.MONTHLY]: [],
        [TaxCategory.CAPITALIZED]: []
    };

    const pushToCategory = (cat: TaxName, item: paymentServicesTypes.TaxItem) => {
        const key = String(cat);
        categorizedTaxes[key].push(item);
    };

    taxItems.forEach((item) => {
        switch (item.taxName) {
            case TaxNames.MonthlyUseTax: {
                pushToCategory(TaxCategory.MONTHLY, item);
                break;
            }

            case TaxNames.CapCostReduction: {
                pushToCategory(getTaxCategory(cappedFlags.isCrtCapped), {
                    ...item,
                    isCapitalize: cappedFlags.isCrtCapped
                });
                break;
            }

            default: {
                pushToCategory(getTaxCategory(cappedFlags.isTaxCapped), {
                    ...item,
                    isCapitalize: cappedFlags.isTaxCapped
                });
                break;
            }
        }
    });

    return categorizedTaxes;
};
